import { usePostHttp } from "../../../../hooks/http/http.hook";

interface IResponse {
  success: boolean;
}

export function useReleaseEarningsHttp() {
  return usePostHttp<null, IResponse>({
    path: "/brand/campaigns/:id/release-earnings",
  });
}
